import { createApp } from 'vue'
import options from './CheckoutHeader.options'

const el = '.kb-component--checkout-header'
const DOM = document.querySelector(el)

export default function (Store) {
    if (DOM && !DOM.hasAttribute('data-v-app')) {
        const template = DOM.outerHTML
        options.template = template
        const component = createApp(options).use(Store)
        component.mount(DOM)
    }
}
